import DOMPurify from 'dompurify';

export interface SanitizeOptions {
  allowedTags?: string[];
  maxLength?: number;
  allowedAttributes?: string[];
  allowDataImages?: boolean;
}

export const sanitizeHtml = (html: string, options: SanitizeOptions = {}) => {
  const {
    allowedTags,
    maxLength,
    allowedAttributes,
    allowDataImages = true,
  } = options;
  // Avoid truncating when we allow data images, to prevent corrupting base64 payloads
  const truncated = allowDataImages
    ? html
    : typeof maxLength === 'number' && maxLength > 0
      ? html.slice(0, maxLength)
      : html;

  return DOMPurify.sanitize(truncated, {
    ALLOWED_TAGS: allowedTags,
    ALLOWED_ATTR: allowedAttributes,
    ADD_DATA_URI_TAGS: allowDataImages ? ['img'] : [],
    ALLOWED_URI_REGEXP:
      /^(?:(?:https?|mailto|tel|data|blob):|[^a-z]|[a-z+.-]+(?:[^a-z+.-]|$))/i,
    USE_PROFILES: { html: true },
  });
};

export const defaultSignatureSanitizeOptions: SanitizeOptions = {
  maxLength: 2000,
  allowedTags: [
    'div',
    'p',
    'span',
    'strong',
    'em',
    'br',
    'table',
    'tr',
    'td',
    'a',
    'img',
  ],
  allowedAttributes: [
    'href',
    'target',
    'rel',
    'src',
    'alt',
    'style',
    'width',
    'height',
  ],
  allowDataImages: true,
};
